import styled from 'styled-components';

import { BodyCopy } from '@xingternal/typography';

export const CommonContactBodyCopy = styled(BodyCopy)`
  flex-direction: column;
  align-items: flex-start;
`;

export const ContactWrapper = styled.div`
  cursor: pointer;
`;
